/**
 * 初回パスワード変更フォーム
 *
 * 初回ログイン時に強制表示される。
 * 管理者が設定した初期パスワードから、本人のパスワードに変更する。
 * 共通の PasswordFormFields を案内バナー付きで使用する。
 */

import { type FC } from "react";
import { PasswordFormFields } from "./PasswordFormFields";

interface InitialPasswordFormProps {
  onSuccess: () => void;
}

const InitialBanner = (
  <div className="rounded-lg bg-brand-50 border border-brand-200 p-4">
    <p className="text-sm text-brand-700">
      セキュリティのため、初回ログイン時にパスワードの変更が必要です。
    </p>
  </div>
);

export const InitialPasswordForm: FC<InitialPasswordFormProps> = ({ onSuccess }) => (
  <PasswordFormFields
    submitLabel="パスワードを設定する"
    currentPasswordPlaceholder="初期パスワードを入力"
    banner={InitialBanner}
    onSuccess={onSuccess}
  />
);
